/**
 * admin/src/pages/LoginPage.tsx
 * Trang đăng nhập Admin
 */

// API origin cho login:
// - Production (admin.luyenthi.io.vn): gọi Worker production
// - Local dev (localhost:5181):  gọi staging Worker + ?local=true
//   → OAuth callback sẽ redirect về localhost:5181 thay vì admin.luyenthi.io.vn
const API_ORIGIN = import.meta.env.PROD
  ? 'https://luyenthi.io.vn'
  : 'https://dev.luyenthi.io.vn'; // dùng staging OAuth (đã đăng ký Google)

export function LoginPage() {
  function handleGoogleLogin() {
    // Redirect sang Google OAuth flow trên Worker
    // ?local=true → sau auth, admin-bridge sẽ redirect về localhost:5181
    const localParam = import.meta.env.PROD ? '' : '&local=true';
    window.location.href = `${API_ORIGIN}/api/auth/google?${localParam}`;
  }


  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-card__logo">
          <span className="login-card__dot" />
          luyenthi.io.vn
        </div>

        <h1 className="login-card__title">Admin Dashboard</h1>
        <p className="login-card__sub">
          Đăng nhập bằng tài khoản Google được cấp quyền admin.
        </p>

        {/* Google Login Button */}
        <button
          id="btn-google-login"
          className="login-card__btn-google"
          onClick={handleGoogleLogin}
        >
          {/* Google SVG icon */}
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path
              fill="#4285F4"
              d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18Z"
            />
            <path
              fill="#34A853"
              d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17Z"
            />
            <path
              fill="#FBBC05"
              d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07Z"
            />
            <path
              fill="#EA4335"
              d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.31Z"
            />
          </svg>
          Đăng nhập với Google
        </button>

        <p className="login-card__notice">
          Chỉ các email được cấp phép mới có thể truy cập.
          <br />
          Liên hệ admin nếu cần thêm quyền.
        </p>
      </div>
    </div>
  );
}
